import { STORAGE_LNG } from "config/const/global";
import { isEmpty, isEqual } from "lodash";

/**
 * set cookie with key-value({@link cname}-{@link cvalue})
 * @param {String} cname cookie's key
 * @param {String} cvalue cookie's value
 * @param {Number} [exdays = 90] expire time, default to 3 months
 */
export function setCookie(cname, cvalue, exdays = 90) {
    let val = isEmpty(cvalue) ? '' : JSON.stringify(cvalue)
    localStorage.setItem(cname, val)
}

/**
 * get cookie's value by {@link cname}
 * @param {String} cname cookie's key
 * @returns cookie's value, '' will return if there arent exist {@link cname}
 */
export function getCookie(cname) {
    let val = localStorage.getItem(cname)
    if (cname === STORAGE_LNG) return val
    else return isEmpty(val) ? '' : JSON.parse(val)
}

/**
 * delete cookie by {@link cname}
 * @param {String} cname cookie's key
 */
export function delCookie(cname) {
    localStorage.removeItem(cname)
}

/**
 * compare two cookiews' value same or not
 * @param {String} c1 the cookie key name
 * @param {String} c2 the other cookie key name
 * @returns true if both cookies' value are same, otherwise false
 */
export function compareCookie(c1, c2) {
    return isEqual(String(getCookie(c1)), String(getCookie(c2)))
}